<div class="modal-header">
    <h4 class="modal-title">{{title}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="exit()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    {{content}}
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" aria-label="Close" (click)="exit()">
        Close
    </button>
</div>
